

export class featureInactiveQueries {

    private _inactiveQueries: string[] = [];
    private enabled: boolean = true;

    setActiveQuery(key: string, isActive: boolean): void {
        if (isActive) {
            if (this._inactiveQueries.includes(key)) {
                this._inactiveQueries = this._inactiveQueries.filter((item: string) => item !== key);
            }
        } else {
            if (!this._inactiveQueries.includes(key)) {
                this._inactiveQueries.push(key);
            }
        }
    }

    setEnabled(enabled: boolean): void {
        this.enabled = enabled;
    }

    getEnabled(): boolean {
        return this.enabled;
    }

    setInActiveQueries(keys: string[]): void {
        this._inactiveQueries = keys;
    }

    getInActiveQueries(): string[] {
        return this._inactiveQueries;
    }

    isActiveQuery(key: string): boolean {
        return !this._inactiveQueries.includes(key); //|| !this.enabled;
    }

    removeKeyFromInactiveQueries(key: string): void {
        this._inactiveQueries = this._inactiveQueries.filter((item: string) => item !== key);
    }

    removeUnusedKeys(keys: string[]): string[] {
        this._inactiveQueries = this._inactiveQueries.filter((item: string) => keys.includes(item));
        return this._inactiveQueries;
    }

}